import { Link, Stack, styled, Typography } from '@mui/material';
import { NavLink } from 'react-router';
import Logo from '../../assets/icons/Logo';
import StyledButton from '../Button';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  borderBottom: '1px solid #CCCCCC',
  height: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  padding: '16px 24px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'start',
  },
}));

export const StyledLogoContainer = styled(Link)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  textDecoration: 'none',
}));

export const StyledLogoImage = styled(Logo)(() => ({
  color: '#080808',
}));

export const StyledLogoLabel = styled(Typography)(() => ({
  textTransform: 'uppercase',
  fontSize: '12px',
  color: '#6D77C8',
}));

export const StyledLinksContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: 40,
  [theme.breakpoints.down('md')]: {
    gap: '24px',
  },
}));

export const StyledLink = styled(NavLink)(() => ({
  color: '#080808',
  '&.active, &:hover': {
    color: '#6D77C8',
  },
}));

export const StyledLoginButton = styled(StyledButton)(() => ({
  background: '#6D77C8',
  color: '#FFFFFF',
  '&:hover': {
    opacity: 1,
    backgroundColor: '#575FA0',
  },
}));
